import React from 'react';
import { useLocation } from 'react-router';

import { CLIENT_ROUTES } from '../../constants';
import { lastVisited } from '../../tools/lastVisited';

function Watcher(): null {
  const { pathname, search, hash } = useLocation();

  React.useEffect(() => {
    if (Object.values(CLIENT_ROUTES).some(route => route === pathname) || search.includes('?success')) {
      return;
    }

    lastVisited.set(`${pathname}${search}${hash}`);
  }, [pathname, search, hash]);

  return null;
}

export { Watcher };
